
export const NOMBRES_HABILITADOS = [
    'miqueasdavidgentile@gmail.com',
    'm.gentile@bimtrazer.com',
    'paulablason68@gmail.com',
    'p.blason@bimtrazer.com',
    'edangelosante@gmail.com',
    'guillermo.pianta@gmail.com',
    'cpmarceloorione@gmail.com',
    'n.ruiz@bimtrazer.com',
    'l.idbetan@bimtrazer.com',
    'm.lombardo@bimtrazer.com',
    's.perichon@bimtrazer.com',
    'justinacid20@gmail.com',
    'j.cid@bimtrazer.com',
    'j.velazquez@bimtrazer.com'
]

export const MAILS_VALIDS = [
    ...NOMBRES_HABILITADOS,
    'cabrera@ggsa.com.ar',
    'pomponio@ggsa.com.ar',
    'flores@ggsa.com.ar',
    'gastaldi@ggsa.com.ar',
    'brian.gonzalez@ggsa.com.ar',
    'arriola@ggsa.com.ar',
    'murugarren@ggsa.com.ar',
    'franco@ggsa.com.ar',
    'quijano@ggsa.com.ar',
    'casagrande@ggsa.com.ar',
    'jimeno@ggsa.com.ar',
    'lagier@ggsa.com.ar',
    'aguero@ggsa.com.ar',
    'fregenal@ggsa.com.ar',
    'arganaraz@ggsa.com.ar'
]